import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryOverview from './components/CategoryOverview';
import FeaturedDownloads from './components/FeaturedDownloads';
import LatestArticles from './components/LatestArticles';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爱液下载',
    url: 'https://www.aiyexiazai.com/',
    description: '爱液下载为您提供安全、快速、免费的资源下载服务。海量正版内容一键获取，支持多平台兼容。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.aiyexiazai.com/category?search={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爱液下载',
    url: 'https://www.aiyexiazai.com/',
    description: '安全快速免费的资源下载平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      email: 'support@aiyexiazai.com',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryOverview />
        <FeaturedDownloads />
        <StatsSection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}